export const preparePopulationData = (data: populationdataElementRaw[]) => {
  const formated = {} as populationdataset

  data.map(d => {
    const obj = {} as populationdataElement

    Object.keys(d).forEach(k => {
      obj[k as keyof populationdataElement] = +d[
        k as keyof populationdataElementRaw
      ]
    })

    formated[+d.birthyear] = obj
  })

  return formated
}
export const prepareNameData = (
  data: { Vorname: string; Total: string; [key: string]: string }[],
  popdata: populationdataset,
  gender: 'm' | 'w'
) => {
  const formated: namedataElement[] = data.map((d, i) => {
    const obj: namedataElement = {
      name: d.Vorname,
      sum: +d.Total,
      gender,
      years: []
    }

    const { Vorname, Total, ...e } = d

    Object.keys(e).forEach(k => {
      const year = +k
      const abs = +d[k]
      const pop = 
        (abs * 100) / (gender === 'w' ? popdata[year].women : popdata[year].men)

      obj.years.push({ abs, pop: +pop.toFixed(2), year })
    })
    return obj
  })
  return formated
}
